import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Clock } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-14 px-4 bg-slate-950 relative overflow-hidden" data-id="element-46">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-teal-900/20 via-slate-950 to-slate-950 pointer-events-none" data-id="element-47"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-49">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wider border border-red-500/20 mb-6" data-id="element-50">
            <Clock className="w-4 h-4" data-id="element-51" /> Oferta por tiempo limitado
          </div>
          <h2 className="text-3xl md:text-6xl font-black text-white mb-4" data-id="element-52">
            Este es el momento
          </h2>
          <p className="text-lg text-slate-300 mb-1" data-id="element-53">
            Podés seguir como estás…
          </p>
          <p className="text-xl font-bold text-teal-400" data-id="element-54">
            O podés dar el paso hacia una práctica profesional real.
          </p>
          <p className="text-lg text-slate-400 mt-4 font-medium" data-id="element-55">
            No mañana. No después.{' '}
            <span className="text-amber-400 font-bold" data-id="element-56">👉 Ahora.</span>
          </p>
        </motion.div>

        <div className="bg-slate-900 border-2 border-teal-500/30 rounded-2xl p-6 md:p-10 shadow-2xl shadow-teal-900/20 text-center" data-id="element-57">
          <h3 className="text-2xl md:text-3xl font-black text-white mb-1" data-id="element-58">
            KIT ORTOPEDISTA PRO
          </h3>
          <p className="text-teal-400 font-bold mb-6 text-sm" data-id="element-59">
            + Todos los bonos exclusivos
          </p>

          <div className="mb-4" data-id="element-60">
            <p className="text-slate-400 text-sm mb-1" data-id="element-61">Precio regular:</p>
            <p className="text-2xl text-slate-500 line-through font-bold decoration-red-500/50" data-id="element-62">
              $49.990
            </p>
          </div>

          <div className="mb-6" data-id="element-63">
            <p className="text-amber-400 font-bold text-lg mb-1" data-id="element-64">
              Precio único por hoy:
            </p>
            <p className="text-5xl md:text-7xl font-black text-white drop-shadow-lg" data-id="element-65">
              $19.990
            </p>
            <p className="text-slate-400 mt-1 text-xs" data-id="element-66">
              Pesos Argentinos. Pago único. Acceso de por vida.
            </p>
          </div>

          <CTAButton text="ACCEDÉ AL KIT AHORA" href="https://checkout.abastecedordigital.shop/cart/51662528086336:1" className="text-lg md:text-2xl py-4" data-id="element-67" />
          <p className="text-white font-bold text-lg mt-4" data-id="element-68">
            Y empezá a trabajar como un verdadero profesional.
          </p>

          <div className="flex items-center justify-center gap-2 mt-6 text-slate-400 text-sm" data-id="element-69">
            <ShieldCheck className="w-5 h-5 text-teal-500" data-id="element-70" />
            <span data-id="element-71">Pago 100% seguro y encriptado</span>
          </div>
        </div>
      </div>
    </section>;
}